angular.module('qkr').controller('ReportManagerController', function(merchantService, usSpinnerService, messageService,
                                                                     appConfig,  checkBrowserService, $uibModal) {
    const reportManagerCtrl = this;

    reportManagerCtrl.username = appConfig.username;
    reportManagerCtrl.displayUnsupportedBrowserAlert = appConfig.displayUnsupportedBrowserAlert;
    reportManagerCtrl.isPartner = appConfig.isPartner;
    const startSpin = function() {
        usSpinnerService.spin('spinner-merchant');
    };
    const stopSpin = function() {
        usSpinnerService.stop('spinner-merchant');
    };

    const init = function() {
        if (reportManagerCtrl.displayUnsupportedBrowserAlert) {
            if (checkBrowserService.isUnsupportedBrowser()) {
                const modalInstance = $uibModal.open({
                    template: require('../templates/browserAlertDialog.html'),
                    controller: 'BrowserAlertController',
                    windowClass: 'fade',
                    backdrop: 'static',
                    resolve: {}
                });

                modalInstance.result.then((result) => {
                    if (result) {
                    }
                }, () => {
                });
            }
        }
        stopSpin();

        merchantService.loadMerchantInfo().then(
            (response) => {
                reportManagerCtrl.merchant = response;

                reportManagerCtrl.seatingMap =
                    merchantService.behaviour(reportManagerCtrl.merchant, 'adminPage.hidePaymentGateway');
            },
            (reason) => {
                messageService.error('merchant load ', reason);
            }
        );
    };

    reportManagerCtrl.containRole = function(role) {
        return appConfig.userRoles.indexOf(role) !== -1;
    };

    // When your view loads, so does its associated controller. Instead of using ng-init, simply call your init()  Since your controller runs before ng-init
    init();
});



// WEBPACK FOOTER //
// ./src/controllers/reportManager.controller.js